import {
  JupiterTheme,
  EntitlementsFeatureTooltip,
} from '@jupiterone/jupiter-web-toolkit';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { AccountModalPage } from 'navbar/src/jupiterAccountSettings/types';
import { NavPage } from './LeftNav';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    dialogNav: {
      width: '100%',
      marginBottom: 60,
      position: 'relative',
      zIndex: 3,
    },
    navButton: {
      border: `solid 1px ${theme.palette.primary}`,
      boxShadow: '0 0 25px 0 rgb(0, 6, 42, 0.1)',
      background: 'rgba(249, 249, 249, .5)',
      color: theme.palette.primary.main,
      margin: 8,
      '&:hover, &:focus': {
        color: theme.palette.primary.contrastText,
        background: theme.palette.primary.main,
      },
      '& svg': {
        width: 20,
        height: 20,
      },
    },
    navButtonActive: {
      color: theme.palette.primary.main,
    },
  })
);

interface IProps {
  activePage: AccountModalPage;
  navPages: NavPage[];
  onPageChange: (newPage: AccountModalPage) => void;
}

const IconAvatarNav = ({ activePage, navPages, onPageChange }: IProps) => {
  const classes = useStyles();
  return (
    <Grid container justify="center" className={classes.dialogNav}>
      {navPages.map((p: NavPage) => (
        <Grid item key={p.key}>
          {p.entitlement ? (
            <EntitlementsFeatureTooltip
              entitlement={p.entitlement}
              fallbackTitle={p.name}
              enterDelay={500}
              placement="top"
            >
              {(hasEntitlement) => (
                <IconButton
                  disabled={!hasEntitlement}
                  onClick={() => {
                    onPageChange(p.key);
                  }}
                  className={clsx(
                    classes.navButton,
                    p.key === activePage && classes.navButtonActive
                  )}
                >
                  {p.icon}
                </IconButton>
              )}
            </EntitlementsFeatureTooltip>
          ) : (
            <Tooltip title={p.name} enterDelay={500} placement="top">
              <IconButton
                onClick={() => {
                  onPageChange(p.key);
                }}
                className={clsx(
                  classes.navButton,
                  p.key === activePage && classes.navButtonActive
                )}
              >
                {p.icon}
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default IconAvatarNav;
